module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity1.9d04e704.jpg";